const initials = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("") || "?";

export default function CustomerAvatar({ customer, size = 36, testId }) {
    const style = { width: size, height: size, fontSize: Math.max(10, size * 0.36) };
    if (customer?.photo_url) {
        return <img src={customer.photo_url} alt={customer.name} style={style} className="rounded-full object-cover shrink-0 border border-slate-200" data-testid={testId} />;
    }
    return (
        <span style={style} className="rounded-full shrink-0 grid place-items-center font-display font-black bg-[hsl(var(--primary)/0.14)] text-[hsl(var(--primary))]" data-testid={testId}>
            {initials(customer?.name)}
        </span>
    );
}
